// DetailHeader — the identity row at the top of every user detail page: avatar, name, email, code
// and role, an optional badge, and Delete. Delete is hidden for admins and for the signed-in admin;
// the API is the authority on whether it is allowed. After a delete it returns to that role's tab.
import { useNavigate } from "react-router-dom";
import type { ReactNode } from "react";
import type { Role } from "@dm-lms/shared/types";
import Avatar from "../shared/Avatar.js";
import DeleteUserButton from "./DeleteUserButton.js";
import { useAuth } from "../../hooks/useAuth.js";

interface DetailHeaderProps {
  user:   { id: string; code: string; name: string; email: string; role: Role };
  badge?: ReactNode;
}

export default function DetailHeader({ user, badge }: DetailHeaderProps) {
  const { user: me } = useAuth();
  const navigate = useNavigate();
  const canDelete = user.role !== "admin" && user.id !== me?.id;

  return (
    <div className="mb-4 flex items-start justify-between gap-3">
      <div className="flex items-center gap-4">
        <Avatar name={user.name} size="md" />
        <div>
          <p className="font-medium text-dm-navy">{user.name}</p>
          <p className="text-sm text-dm-slate">{user.email}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {badge}
        {canDelete && (
          <DeleteUserButton
            id={user.id}
            code={user.code}
            onDeleted={() => { navigate(`/app/admin/users?role=${user.role}`, { replace: true }); }}
          />
        )}
      </div>
    </div>
  );
}
